import React from "react";
import {Typography} from "../../../../designSystem/components/Typography";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {mnaQuestions} from "./constant";

interface MNASFViewProps {
  score: number;
  answers: Record<string, number>;
}

export const MNASFView = ({
  score,
  answers
}: MNASFViewProps) => {
  // Score Interpretation
  const getScoreCategory = (score: number) => {
    if (score >= 12) return { label: "營養良好", color: "bg-green-500" };
    if (score >= 8) return { label: "有營養不良風險", color: "bg-yellow-500" };
    return { label: "營養不良", color: "bg-red-500" };
  };

  const scoreCategory = getScoreCategory(score);

  return (
    <DashboardCard>
      <Typography variant="subtitle">
        MNA-SF 迷你營養評估結果
      </Typography>

      {/* Score Badge */}
      <div className={`text-white font-bold px-4 py-2 rounded-md inline-block ${scoreCategory.color}`}>
        總分: {score} ({scoreCategory.label})
      </div>

      <hr className="my-4" />

      {/* Answer Details - Line by Line */}
      {mnaQuestions.map((q) => {
        const selectedOption = q.options.find(
          (opt) => opt.value === answers[q.id]
        );
        return (
          <div
            key={q.id}
            className="mb-3"
          >
            <p className="text-gray-700 font-medium">
              {q.question}
            </p>
            <p className="text-gray-600 ml-4">
              {selectedOption ? `➤ ${selectedOption.label}` : "未填寫"}
            </p>
          </div>
        );
      })}
    </DashboardCard>
  );
};
